module.exports = __webpack_public_path__ + "img/why-content4.1daace66.png";